///////////////////////////////////////////////////////////////////77
import {
	Carousel,
	CarouselContent,
	CarouselItem,
	CarouselNext,
	CarouselPrevious,
} from '@/app/shared/components';
import { Skin, SkinImage } from '@/core/interfaces';

interface SkinCarouselProps {
	skin: Skin;
}

export const SkinCarousel: React.FC<SkinCarouselProps> = ({ skin }) => {
	/*********************
	// #region Template
	**********************/
	return (
		<Carousel
			opts={{
				startIndex: 0,
			}}
		>
			<CarouselContent>
				{skin &&
					skin.images.map((item: SkinImage, index: number) => {
						return (
							<CarouselItem key={item.image}>
								<div className="flex flex-col mt-4">
									<img
										src={item.image}
										className="max-w-[75%] mx-auto block"
									/>
									<p className="font-bold text-xl text-center mt-4">
										Level {index + 1}
									</p>
								</div>
							</CarouselItem>
						);
					})}
			</CarouselContent>
			<CarouselPrevious
				variant={'arrow'}
				className="left-1 z-20 top-[180px]"
			/>
			<CarouselNext
				variant={'arrow'}
				className="right-1 z-20 top-[180px]"
			/>
		</Carousel>
	);
};
